
export const navDataPrimary = [
    
    {
        text:'Products ',
        url:'/',
        color:'#3884FF'
    },
    {
        text:"Solutions",
        url:"/solutions",
        color:'#E34F26',
    },
    {
        text:"Learning",
        url:"/learn",
        color:'#0095D5',
    },
    {
        text:"Support & Services",
        url:"/support-services"
    },
    {
        text:"Community",
        url:"/community"
    },
    {
        text:"Developer Tools",
        url:"/developer-tools"
    }

]

export const navDataHelp = [
    
    
]
